// Same switch as intellinurse/src/lib/data-provider.ts: VITE_USE_MOCK_DATA=true serves
// every screen from the in-memory mock; otherwise calls go to oneselfpath-service.
import { mockApi } from "./mock-data";
import { realApi, type OneselfPathApi } from "./oneselfpath-api";

export const USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === "true";

export const dataProvider: OneselfPathApi = USE_MOCK_DATA ? mockApi : realApi;
